// API service layer for taxonomy data.
// Responsible only for HTTP calls — no state, no transformation.
// Base URL is configured via REACT_APP_API_BASE_URL in .env.
import { apiRequest } from './apiClient';

export const fetchDomainTree = () => apiRequest('/api/v1/domains/tree');
